import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IEnquiryDocument } from '@simplyfly/shared';
import { EnquiryDocumentFirestoreService } from './enquiry-documents-firestore.service';

@Injectable({
  providedIn: 'root'
})
export class EnquiryDocumentService {
  constructor(private enquiryDocumentFirestoreService: EnquiryDocumentFirestoreService) {}

  create(enquiryDocument: IEnquiryDocument): Promise<string> {
    return this.enquiryDocumentFirestoreService.create(enquiryDocument);
  }

  update(enquiryDocument: IEnquiryDocument): Promise<string> {
    return this.enquiryDocumentFirestoreService.update(enquiryDocument);
  }

  delete(id: string): Promise<void> {
    return this.enquiryDocumentFirestoreService.delete(id);
  }

  getAllForEnquiry(enquiryId: string): Observable<IEnquiryDocument[]> {
    return this.enquiryDocumentFirestoreService.collectionValues$(ref =>
      ref.where('enquiryId', '==', enquiryId)
    );
  }
}
